import { getUserFriendlyMessagesForErrorResponse } from '../../errors/user-friendly-error-message-service';

export const getErrorMessagesFromSaveConfigAndRateResponse = (response) => {
  const { errors, stringErrors } = getUserFriendlyMessagesForErrorResponse(response);
  return errors.length ? errors.map((err) => ({ ...err.messageDescriptor, values: err.values })) : stringErrors;
};
